import { render, staticRenderFns } from "./ApplyGift.vue?vue&type=template&id=4741a4ae&scoped=true"
import script from "./ApplyGift.vue?vue&type=script&lang=js"
export * from "./ApplyGift.vue?vue&type=script&lang=js"
import style0 from "./ApplyGift.vue?vue&type=style&index=0&id=4741a4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4741a4ae",
  null
  
)

export default component.exports